import React, { useState, useRef, useEffect } from 'react';
import { Item } from '../../items/item';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import './style.scss';
import { SiteLink } from '../../../components';

export function WallToWallItem(props) {
    const item = props.item;
    const cmsOption = props.cmsOption || {};

    const bgUrl = utils.site.resourcePath(cmsUtils.payload(item, 'ImageUrl'));
    const alignV = cmsUtils.payload(item, 'VAlign') || '50%';
    const alignH = cmsUtils.payload(item, 'HAlign') || '50%';
    const buttonText = cmsUtils.payload(item, 'ButtonTxt');
    const linkUrl = cmsUtils.payload(item, 'LinkUrl');

    const [hoverTime, setHoverTime] = useState(0);
    const timerRef = useRef(null);

    useEffect(() => {
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, []);

    const handleMouseEnter = () => {
        if (timerRef.current) clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setHoverTime((prev) => (prev < 7 ? prev + 0.1 : prev));
        }, 100);
    };

    const handleMouseLeave = () => {
        if (timerRef.current) clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setHoverTime((prev) => {
                if (prev <= 0) {
                    clearInterval(timerRef.current);
                    return 0;
                }
                return prev - 0.1;
            });
        }, 100);
    };

    const handleClick = () => {
        window.location.href = `${linkUrl}`;
    };

    const cssClass = utils.classNames(
        "cms_item",
        "wall-to-wall-item",
        item.cssClass || item.anchorName || ""
    );

    return (
        <div
            className={cssClass}
            data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
            id={item.anchorName}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div
                className="item-background-image"
                style={{
                    backgroundImage: utils.css.bgUrlStyle(bgUrl),
                    backgroundPositionY: alignV,
                    backgroundPositionX: alignH,
                    transform: `scale(${1 + hoverTime * 0.03})`,
                    transition: "transform 0.1s linear",
                }}
            />
            <SiteLink to={linkUrl} className="cta-button">
                <span>
                    {buttonText}
                </span>
            </SiteLink>
        </div>
    )
}